export default __webpack_public_path__ + "static/9_18-e8748b509eb1f8a06f5b37b6dac7b389.png";